<template>
  <div>
    <panel Title="گزارش پرداخت اینترنتی "
      Des="از طریق این فرم می توانید ریز گزارشات پرداختی اینترنتی خود وافراد وابسته از طریق اینترنت بانک را مشاهده کنید"
      :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <!-- <net-pa-card>
      <template v-slot:header>
        <h6>
          <i class="fas fa-receipt ml-2" aria-hidden="true"></i> گزارش پرداخت
          های خودم
        </h6>
      </template>
      <template v-slot:content>
        <div class="row mb-5">
          <div class="col-12 col-md-4">
            <small>از تاریخ </small>
            <date-picker :editable="true" :auto-submit="true" :max="TaTarix" color="rgb(42 63 84)" v-model="AzTarix">
            </date-picker>
            <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
          </div>
          <div class="col-12 col-md-4">
            <small> تا تاریخ</small>
            <date-picker :editable="true" :auto-submit="true" :min="AzTarix" color="rgb(42 63 84)" v-model="TaTarix">
            </date-picker>
            <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
          </div>
          <div class="col-12 col-md-4">
            <input type="button" name="" value="جستجو" class="btn btn-success mt-3 w-100" @click="
                SearchGardesh();
                $ResetTimer();
              " />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-right">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="bestan" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.bestan) }}</p>
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
      </template>
    </net-pa-card> -->
    <net-pa-card >
      <template v-slot:header>
        <h6>
          <i class="fas fa-receipt ml-2" aria-hidden="true"></i> گزارش کلیه پرداخت های اینترنتی (خود و افراد وابسته) </h6>
      </template>
      <template v-slot:content>
        <div class="row mb-5">
          <div class="col-12 col-md-4">
            <small>از تاریخ </small>
            <date-picker :editable="true" :auto-submit="true" :max="TaTarix" color="#435ebe"
              v-model="AzTarixSahebHesab"></date-picker>
            <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr"/>
          </div>
          <div class="col-12 col-md-4">
            <small> تا تاریخ</small>
            <date-picker :editable="true" :auto-submit="true" :min="AzTarix" color="#435ebe"  v-model="TaTarixSahebHesab"></date-picker>
            <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
          </div>
          <div class="col-12 col-md-4">
            <input type="button" name="" value="جستجو" class="btn btn-success mt-3 w-100" @click="
                SearchsahebHesab();
                $ResetTimer();
              " />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <vue-bootstrap4-table :rows="rows2" :columns="columns2" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="bestan" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.bestan) }}</p>
              </template>
              <template slot="Action" slot-scope="props">
                <small class="">
                  <div class="btn Pointer btn-outline-info" @click="Detaile(props.row.id)" data-toggle="modal"
                    data-target="#Modal-Orange">
                    <i class="fas fa-list ml-2"></i> جزئیات
                  </div>
                </small>
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
      </template>
    </net-pa-card>
    <modal-custom v-if="$store.state.renderComponent">
      <template v-slot:ContentModalOrange>
        <div class="row">
          <div class="col-12">
            <vue-bootstrap4-table :rows="rows3" :columns="columns3" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
  import VueBootstrap4Table from "vue-bootstrap4-table";
  import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
  import Panel from "../Tools/NetPa/Panel.vue";
  import ModalCustom from "../Tools/ModalCustom.vue";
  export default {
    components: {
      Panel,
      NetPaCard,
      VueBootstrap4Table,
      ModalCustom
    },
    data() {
      return {
        AzTarix: "",
        TaTarix: "",

        AzTarixSahebHesab: "",
        TaTarixSahebHesab: "",

        DataAxiosRow: {
          ArryfildValue: "",
          Method: "Post",
          Action: "GozareshParForWeb",
          Token: this.$session.get("TokenNetPa"),
        },
        DataAxiosRow_SahebHesab: {
          ArryfildValue: "",
          Method: "Post",
          Action: "GozareshParForWeb/GetGozareshSahebHesab",
          Token: this.$session.get("TokenNetPa"),
        },
        DataAxiosRow_Detaile: {
          ArryfildValue: "",
          Method: "Post",
          Action: "GozareshParForWeb/Detaile",
          Token: this.$session.get("TokenNetPa"),
        },
        rows: [],
        rows2: [],
        rows3: [],
        columns: [{
            label: "id",
            name: "id",
            visibility: false,
          },
          {
            label: "ردیف",
            name: "row",
          },

          {
            label: "عنوان تسهیلات",
            name: "desNoe",
          },
          {
            label: "شماره تسهیلات",
            name: "vCode",
          },
          {
            label: "مبلغ واریزی",
            name: "bestan",
          },
          {
            label: "زمان تراکنش",
            name: "zamanInsert",
          },
          {
            label: "تاریخ سند",
            name: "tarixSanad",
          },
          {
            label: "کد رهگیری",
            name: "codeRahgiri",
          },
          {
            label: "شرح واریزی",
            name: "sharhSanad",
          },
        ],
        columns2: [{
            label: "id",
            name: "id",
            visibility: false,
          },
          {
            label: "ردیف",
            name: "row",
          },

          {
            label: "شرح واریزی",
            name: "sharh",
          },
          {
            label: "تاریخ سند",
            name: "tarixSanad",
          },
          {
            label: "کد رهگیری",
            name: "codeRahgiri",
          },
          {
            label: "مبلغ کل واریزی",
            name: "bestan",
          },
          {
            label: "عملیات",
            name: "Action",
          },
        ],
        columns3: [{
            label: "id",
            name: "id",
            visibility: false,
          },
          {
            label: "ردیف",
            name: "row",
          },

          {
            label: "میلغ واریزی",
            name: "mablagh",
          },
          {
            label: "شماره حساب/تسهیلات",
            name: "vCode",
          },
          {
            label: "عنوان حساب/تسهیلات",
            name: "desNoe",
          },
          {
            label: "مشخصات",
            name: "namefamily",
          },
        ],
        config: {
          pagination: true,
          pagination_info: false,
          per_page_options: [10, 20, 30, 50, 100],
          show_refresh_button: false,
          show_reset_button: false,
          checkbox_rows: false,
          rows_selectable: true,
          card_title: "",
          card_mode: false,
          global_search: {
            placeholder: "  جستجو مبلغ و کد رهگیری",
            visibility: true,
            case_sensitive: false,
            showClearButton: true,
            searchOnPressEnter: false,
            searchDebounceRate: 1000,
          },
        },
        classes: {
          table: "table-bordered table-striped table-sm ",
        },
      };
    },
    mounted() {
      this.SearchsahebHesab();
    },
    methods: {
      SearchGardesh() {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId
        );
        formData.append("AzTarix", this.AzTarix);
        formData.append("TaTarix", this.TaTarix);
        this.DataAxiosRow.ArryfildValue = formData;

        this.$PostFormData(this.DataAxiosRow).then((data) => {
          //                console.log(data);
          this.rows = data.result;
        });
      },
      SearchsahebHesab() {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId
        );
        formData.append("AzTarix", this.AzTarixSahebHesab);
        formData.append("TaTarix", this.TaTarixSahebHesab);
        this.DataAxiosRow_SahebHesab.ArryfildValue = formData;

        this.$PostFormData(this.DataAxiosRow_SahebHesab).then((data) => {
          this.rows2 = data.result;
        });
      },
      Detaile(id) {
        let info;
        let list = [];
        this.$store.state.renderComponent = false;
        this.$nextTick(() => {
          this.$store.state.renderComponent = true;
        });
        const formData = new FormData();
        formData.append("wwwtblVarizGorohiId", id);
        this.DataAxiosRow_Detaile.ArryfildValue = formData;

        this.$PostFormData(this.DataAxiosRow_Detaile).then((data) => {
          for (let index = 0; index < data.result.length; index++) {
            info = data.result[index];
            info["row"] = index + 1;
            list.push(info);
          }
          this.rows3 = this.$FormatMablaghGrid(list);
        });
      },
    },
  };
</script>
<style scoped></style>